// stores/router.ts
import { createRouter } from '@nanostores/router';

export const $router = createRouter({
  root: '/',
  customer: '/chat/:customer/',
  register: '/chat/:customer/register',
  login: '/chat/:customer/login',
  article: '/chat/:customer/article/:id',
});

/** The customer shortID from the current route (single source of truth). */
export const getShortID = (): string | undefined => {
  const params = $router.get()?.params;
  if (!params || !('customer' in params)) {
    return undefined;
  }
  return params.customer;
};
